export function mapObject<
  Key extends string,
  InputValue,
  OutputValue = InputValue
>(
  input: Record<Key, InputValue>,
  mapper: (
    [key, value]: [Key, InputValue],
    index?: number
  ) => [Key, OutputValue]
) {
  const entries = Object.entries(input) as Array<[Key, InputValue]>
  return Object.fromEntries(entries.map(mapper)) as Record<Key, OutputValue>
}

export function pick<
  Input extends Record<string, unknown>,
  Keys extends keyof Input
>(input: Input, keys: Keys[]): Pick<Input, Keys> {
  return Object.fromEntries(
    Object.entries(input).filter(([key]) => (keys as string[]).includes(key))
  ) as Pick<Input, Keys>
}

export function omit<
  Input extends Record<string, unknown>,
  Keys extends keyof Input
>(input: Input, keys: Keys[]): Omit<Input, Keys> {
  return Object.fromEntries(
    Object.entries(input).filter(([key]) => !(keys as string[]).includes(key))
  ) as Omit<Input, Keys>
}
